import React from 'react';
import {CoreDI, IEventManagerWithAsync, lazyInject, ScreenManager, ScreenParameters} from '@gongxigames/framework/core';
import {GlobalEventsMap} from '@gongxigames/framework/slot/events';
import {CheatPluginView} from '../../CheatPluginView';
import {CheatSettingsController, SettingAction} from './CheatSettingsController';
import {ToggleButtonWithTitle} from '../../components/ToggleButtonWithTitle';
import {DisplayObjectList} from '../../components/DisplayObjectList';

type CheatPluginViewState = {
    width: number;
    height: number;
};

export class CheatSettingsView extends CheatPluginView<CheatSettingsController, {}, CheatPluginViewState> {
    @lazyInject(CoreDI.IEventManagerWithAsync)
    protected eventManager!: IEventManagerWithAsync<GlobalEventsMap>;

    @lazyInject(CoreDI.ScreenManager)
    protected fullscreenManager!: ScreenManager;

    constructor(props: {}) {
        super(props as any);

        this.state = {
            width: this.fullscreenManager.width,
            height: this.fullscreenManager.height
        };
    }

    public componentDidMount(): void {
        this.controller.onChanged = () => this.forceUpdate();
        this.eventManager.on('General.Screen.RESIZED', this.onResized.bind(this), this);
    }

    public componentWillUnmount(): void {
        this.controller.onChanged = () => {};
        this.eventManager.off('General.Screen.RESIZED', this);
    }

    protected onResized({width, height}: ScreenParameters): void {
        this.setState({width, height});
    }

    protected onSelectSettingAction(actionID: string): void {
        this.controller.toggleSettings(actionID);
    }

    protected getToggleButton(action: SettingAction, selected: boolean): JSX.Element {
        return <ToggleButtonWithTitle
            key={action.id}
            title={action.id}
            onChange={this.onSelectSettingAction.bind(this, action.id)}
            width={'auto'}
            height={200}
            fontSize={50}
            value={selected}
        />;
    }

    public render(): JSX.Element {

        const {selectedSettings, settingsActions} = this.controller;

        return (
            <DisplayObjectList direction={'column'} gapBetweenChildren={20} wrap={this.state.height + 99999}>
                {
                    settingsActions.map(action => this.getToggleButton(action, selectedSettings.includes(action.id)))
                }
            </DisplayObjectList>
        );
    }
}
